import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.less';

export const WeightDisplay = ({ weight, unit }) => (
  <span className={style['value-unit']} data-testid='weight-display'>
    <span className={style.value}>{weight}</span>
    <span className={style.unit}>{unit}</span>
  </span>
);

WeightDisplay.propTypes = {
  weight: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
};
